import { Box, Button, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import config from '../../utils/config';
import { useNavigate, useParams } from 'react-router-dom';
import headers from '../../utils/headers';
import { toast } from 'react-toastify';
import moment from 'moment';

export default function StudentProfile(props) {
    const { studentId } = useParams();
    const navigate = useNavigate();

    const [studentProfile, setStudentProfile] = useState(null);
    const [organization, setOrganization] = useState(null);

    useEffect(() => {
        props.setTitle("Student Profile");
        fetchStudent();
    }, []); // eslint-disable-line

    useEffect(() => {
        fetchOrganization();
    }, [props.organization]); //eslint-disable-line

    const fetchOrganization = () => {
        axios
            .get(`${config.API_ENDPOINT}/organizations/${props.organization}`, { headers: { "x-access-token": localStorage.getItem("access-token") } })
            .then(res => {
                setOrganization(res.data);
            })
            .catch(err => {
                switch (err.response?.status) {
                    case 401:
                        localStorage.removeItem("access-token");
                        window.location.replace("/login");
                        break;
                    default:
                        toast.error("An unexpected error has occurred");
                        break;
                }
            });
    }

    const fetchStudent = () => {
        axios
            .get(`${config.API_ENDPOINT}/students/${props.organization}/${studentId}/profile`, headers())
            .then((res) => setStudentProfile(res.data))
            .catch((err) => {
                switch (err.response?.status) {
                    case 401:
                        localStorage.removeItem("access-token");
                        window.location.replace("/login");
                        break;
                    default:
                        toast.error("An unexpected error has occurred");
                        break;
                }
            });
    };

    const getStudentInfo = () => {
        return <Box>
            <Box sx={{ mb: 4, pb: 3, borderBottom: "1px solid rgba(19, 33, 68, 0.1)" }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>{studentProfile.student.name}</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>Student Profile</Typography>
            </Box>

            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Personal Information</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Gender</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                {studentProfile.student.gender === "male" ? "Male" : studentProfile.student.gender === "female" ? "Female" : studentProfile.student.gender === "other" ? "Other" : "-"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Email</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.email}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Phone</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.phone || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>ID/Passport</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.passport}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Birthdate</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                {studentProfile.student.birthdate ? moment.utc(studentProfile.student.birthdate).format("DD/MM/YYYY") : "-"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Nationality</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.country}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Address</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.address || "-"}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Erasmus Information</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>ESNcard</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.esnCard || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>University</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.university}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Program</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.program}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Duration</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.programDuration}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Registration Date</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                {studentProfile.student.registerDate ? moment(studentProfile.student.registerDate).format("DD/MM/YYYY") : "-"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>Newsletter Consent</Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>{studentProfile.student.newsletter ? "Yes" : "No"}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {getCustomQuestions()}
        </Box>;
    };

    const getCustomQuestions = () => {
        if (organization == null || organization.customEsnCardQuestions == null) return null;
        const cq = studentProfile.student.customQuestions ?? {};
        if (organization.customEsnCardQuestions.length === 0) return null;

        return (
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Custom Questions</Typography>
                    <Grid container spacing={2}>
                        {organization.customEsnCardQuestions.map(q => (
                            <Grid item xs={12} sm={6} key={q.id}>
                                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>{q.question}</Typography>
                                <Typography variant="body2" sx={{ mt: 0.5 }}>
                                    {getQuestionValue(cq[q.id], q.type) || "-"}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>
        );
    };

    const getQuestionValue = (value, type) => {
        if (value == null || value === "") return "";

        switch (type) {
            case "select-multi":
                return value.join(', ');
            case "datetime":
                return moment(value).format("DD-MM-YYYY HH:mm");
            default:
                return value;
        }
    }

    const getEventsInfo = () => {
        return <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                    <CardContent>
                        <Typography sx={{ fontWeight: "bold", fontSize: 20, textAlign: "center" }}>
                            Events Purchased
                        </Typography>
                        <Typography
                            sx={{ fontWeight: "bold", fontSize: 50 }}
                            color="primary"
                            align="center"
                        >
                            {studentProfile.events.purchased}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                    <CardContent>
                        <Typography sx={{ fontWeight: "bold", fontSize: 20, textAlign: "center" }}>
                            Events Pending
                        </Typography>
                        <Typography
                            sx={{ fontWeight: "bold", fontSize: 50 }}
                            color="primary"
                            align="center"
                        >
                            {studentProfile.events.pending}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Button variant="contained" sx={{ display: "block", m: "0 auto", mt: 2 }} onClick={() => navigate(`/event-purchases?esnCard=${studentProfile.student.esnCard}`)}>
                    View Student Event Purchases
                </Button>
            </Grid>
        </Grid>;
    };

    if (studentProfile == null) {
        return <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress />
        </Box>;
    }

    return (
        <Box>
            {getStudentInfo()}
            {getEventsInfo()}
        </Box>
    )
}
